/**
 * The static "How the calculator works" block in index.html (#calc-about).
 *
 * It lives in index.html so crawlers that do not run JavaScript see real text on
 * the page. On mount it is moved into <main>, above the footer, so readers and
 * crawlers see the same single copy instead of a block stranded after the app.
 */
export function adoptAbout(doc: Document, mainEl: HTMLElement): HTMLElement | null {
  const about = doc.getElementById("calc-about");
  if (!about) return null;
  mainEl.append(about);
  return about;
}
